import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./ProfileMobile.css";

class ProfileMobile extends Component {
  constructor(props) {
    super(props);

    this.fileInputRef = React.createRef();

    // Change these endpoints only when your CodeIgniter route names are different.
    this.API = {
      profile: (id) => `/profile_data/${id}`,
      uploadProfileImage: (id) => `/upload_profile_image/${id}`,
      saveProfile: "profile_save",
      bookings: (id) => `/bookings_data/${id}`,
      payoutHistory: (id) => `/payout_history/${id}`,
      payoutAccount: (id) => `/payout_account/${id}`,
      savePayoutAccount: "payout_account_save",
      withdrawalRequest: "withdrawal_request"
    };

    this.state = {
      fullName: "",
      dob: "",
      phone: "",
      email: "",
      customer_image: "",

      currentView: "main", // main | edit | notifications | payment_history | payout_history
      paymentTab: "past", // past | future
      payoutTab: "withdrawals", // withdrawals | account
      activePopup: null,

      originalProfile: {
        fullName: "",
        dob: "",
        phone: "",
        email: "",
        customer_image: ""
      },

      loading: false,
      saving: false,
      loadingPayments: false,
      paymentsError: null,
      pastPayments: [],
      futurePayments: [],

      loadingPayout: false,
      payoutError: null,
      payoutHistory: [],
      payoutAccount: null,
      payoutAccountLoaded: false,
      savingPayoutAccount: false,
      requestingWithdrawal: false,

      payoutSummary: {
        totalAmount: 0,
        pendingAmount: 0,
        withdrawnAmount: 0,
        availableAmount: 0
      },

      withdrawalForm: {
        amount: "",
        note: ""
      },

      payoutForm: {
        method: "bkash",
        accountName: "",
        accountNumber: "",
        bankName: "",
        branchName: "",
        routingNumber: ""
      },

      notifications: [
        {
          id: 1,
          title: "Booking Confirmed",
          message: "Your reservation #67 for Full Studio Apartment has been updated.",
          time: "2 hours ago",
          unread: true,
          type: "booking"
        },
        {
          id: 2,
          title: "Payment Received",
          message: "Payment for booking #67 was processed successfully.",
          time: "Yesterday",
          unread: false,
          type: "payment"
        }
      ]
    };

    this.contactPhone = "+8801322939334";
    this.whatsappPhone = "8801322939334";
  }

  componentDidMount() {
    const web_user_id = localStorage.getItem("web_user_id");
    if (!web_user_id) {
      window.location.href = "/searchresultmobile";
      return;
    }

    this.fetchProfileData();
    this.fetchBookingsData();
    this.fetchPayoutData();
  }

  getUserId = () => localStorage.getItem("web_user_id");

  normalizeStatus = (value) => String(value || "").trim().toLowerCase();

  toNumber = (value) => {
    const number = parseFloat(String(value ?? "0").replace(/,/g, ""));
    return Number.isFinite(number) ? number : 0;
  };

  formatMoney = (value) => {
    return `৳ ${this.toNumber(value).toLocaleString("en-BD", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })}`;
  };

  // ----------------------------- PROFILE -----------------------------
  fetchProfileData = async () => {
    try {
      this.setState({ loading: true });
      const web_user_id = this.getUserId();
      if (!web_user_id) return;

      const response = await axios.get(this.API.profile(web_user_id));
      const data = response?.data?.data;
      if (!data) return;

      const profileData = {
        fullName: data.full_name || "",
        dob: data.dateofbirth || "",
        phone: data.phone || "",
        email: data.email || "",
        customer_image: data.customer_image || ""
      };

      this.setState({
        ...profileData,
        originalProfile: { ...profileData }
      });
    } catch (error) {
      console.error("Profile fetch error:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleAvatarClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const web_user_id = this.getUserId();
    if (!web_user_id) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(
        this.API.uploadProfileImage(web_user_id),
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200 || response.data?.success) {
        alert("Profile image uploaded successfully!");
        await this.fetchProfileData();
      }
    } catch (error) {
      console.error("Image upload processing failure:", error);
      alert("Failed to upload image. Please try again.");
    } finally {
      if (this.fileInputRef.current) this.fileInputRef.current.value = "";
    }
  };

  handleSave = async (e) => {
    e.preventDefault();
    const { fullName, email, dob } = this.state;
    const web_user_id = this.getUserId();
    if (!web_user_id) return;

    const cleanFullName = fullName.trim().replace(/\s+/g, " ");
    if (!cleanFullName) {
      alert("Please enter your full name.");
      return;
    }

    const formData = new FormData();
    formData.append("id", web_user_id);
    formData.append("full_name", cleanFullName);
    formData.append("email", email);
    formData.append("dateofbirth", dob);

    try {
      this.setState({ saving: true });
      await axios.post(this.API.saveProfile, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      await this.fetchProfileData();
      this.setState({ currentView: "main" });
      alert("Profile saved successfully!");
    } catch (error) {
      console.error("Profile save error:", error);
      alert("Failed to save profile. Please try again.");
    } finally {
      this.setState({ saving: false });
    }
  };

  handleCancel = () => {
    this.setState((prevState) => ({
      fullName: prevState.originalProfile.fullName,
      dob: prevState.originalProfile.dob,
      phone: prevState.originalProfile.phone,
      email: prevState.originalProfile.email,
      customer_image: prevState.originalProfile.customer_image,
      currentView: "main"
    }));
  };

  // ----------------------------- BOOKINGS / PAYMENTS -----------------------------
  fetchBookingsData = async () => {
    const web_user_id = this.getUserId();
    if (!web_user_id) return;

    try {
      this.setState({ loadingPayments: true, paymentsError: null });

      const response = await axios.get(this.API.bookings(web_user_id));
      const rawData = response?.data?.data || [];

      // Future = Pending + Unpaid.
      const futurePayments = rawData.filter(
        (item) =>
          this.normalizeStatus(item.booking_status) === "pending" &&
          this.normalizeStatus(item.payment_status) === "unpaid"
      );

      // Past / eligible host payout = Confirmed + Paid.
      const pastPayments = rawData.filter(
        (item) =>
          this.normalizeStatus(item.booking_status) === "confirmed" &&
          this.normalizeStatus(item.payment_status) === "paid"
      );

      this.setState({ pastPayments, futurePayments });
      this.recalculatePayoutSummary(pastPayments, this.state.payoutHistory);
    } catch (error) {
      console.error("Error fetching bookings data:", error);
      this.setState({
        paymentsError: "Failed to load booking payments. Please try again."
      });
    } finally {
      this.setState({ loadingPayments: false });
    }
  };

  getPaymentAmount = (item) => {
    return this.toNumber(
      item.host_payout_amount ??
        item.host_amount ??
        item.payout_amount ??
        item.total_amount
    );
  };

  isPaymentAlreadyAllocated = (payment, payouts) => {
    const bookingId = String(payment?.id ?? payment?.booking_id ?? "");
    if (!bookingId) return false;

    return (payouts || []).some((payout) => {
      const payoutBookingId = String(
        payout?.booking_id ?? payout?.reservation_id ?? payout?.bookingId ?? ""
      );
      return payoutBookingId === bookingId;
    });
  };

  // ----------------------------- PAYOUT -----------------------------
  fetchPayoutData = async () => {
    const web_user_id = this.getUserId();
    if (!web_user_id) return;

    try {
      this.setState({ loadingPayout: true, payoutError: null });

      const results = await Promise.allSettled([
        axios.get(this.API.payoutHistory(web_user_id)),
        axios.get(this.API.payoutAccount(web_user_id))
      ]);

      let payoutHistory = [];
      let payoutAccount = null;

      if (results[0].status === "fulfilled") {
        payoutHistory = results[0].value?.data?.data || [];
      }

      if (results[1].status === "fulfilled") {
        payoutAccount = results[1].value?.data?.data || null;
      }

      this.setState(
        {
          payoutHistory,
          payoutAccount,
          payoutAccountLoaded: true
        },
        () => this.recalculatePayoutSummary(this.state.pastPayments, payoutHistory)
      );
    } catch (error) {
      console.error("Payout data fetch error:", error);
      this.setState({ payoutError: "Unable to load payout information." });
    } finally {
      this.setState({ loadingPayout: false });
    }
  };

  recalculatePayoutSummary = (payments = [], payouts = []) => {
    const totalAmount = payments.reduce(
      (sum, item) => sum + this.getPaymentAmount(item),
      0
    );

    const paidPayouts = payouts.filter((item) =>
      ["paid", "completed", "complete", "success", "successful", "approved"].includes(
        this.normalizeStatus(item.status ?? item.payout_status)
      )
    );

    const pendingPayouts = payouts.filter((item) =>
      ["pending", "processing", "requested", "under_review"].includes(
        this.normalizeStatus(item.status ?? item.payout_status)
      )
    );

    const withdrawnAmount = paidPayouts.reduce(
      (sum, item) => sum + this.toNumber(item.payout_amount),
      0
    );
    const pendingAmount = pendingPayouts.reduce(
      (sum, item) => sum + this.toNumber(item.payout_amount),
      0
    );

    // Backend-provided summary wins when available.
    const backendSummary = payouts?.summary || null;
    const availableAmount = Math.max(totalAmount - withdrawnAmount - pendingAmount, 0);

    this.setState({
      payoutSummary: {
        totalAmount: this.toNumber(backendSummary?.total_amount ?? totalAmount),
        pendingAmount: this.toNumber(backendSummary?.pending_amount ?? pendingAmount),
        withdrawnAmount: this.toNumber(
          backendSummary?.withdrawn_amount ?? withdrawnAmount
        ),
        availableAmount: this.toNumber(
          backendSummary?.available_amount ?? availableAmount
        )
      }
    });
  };

  setView = (viewName) => {
    this.setState({ currentView: viewName });

    if (viewName === "payment_history") {
      this.fetchBookingsData();
    }

    if (viewName === "payout_history") {
      this.fetchBookingsData();
      this.fetchPayoutData();
    }
  };

  setPaymentTab = (tabName) => {
    this.setState({ paymentTab: tabName });
  };

  setPayoutTab = (tabName) => {
    this.setState({ payoutTab: tabName });
  };

  handleWithdrawalChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      withdrawalForm: {
        ...prevState.withdrawalForm,
        [name]: value
      }
    }));
  };

  handlePayoutAccountChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      payoutForm: {
        ...prevState.payoutForm,
        [name]: value
      }
    }));
  };

  handlePayoutMethodChange = (method) => {
    const current = this.state.payoutAccount || {};
    this.setState({
      payoutForm: {
        method,
        accountName: this.state.payoutForm.accountName || current.account_name || "",
        accountNumber: this.state.payoutForm.accountNumber || current.account_number || "",
        bankName: this.state.payoutForm.bankName || current.bank_name || "",
        branchName: this.state.payoutForm.branchName || current.branch_name || "",
        routingNumber: this.state.payoutForm.routingNumber || current.routing_number || ""
      }
    });
  };

  openPayoutSection = () => {
    this.setState({
      payoutTab: "withdrawals",
      withdrawalForm: { amount: "", note: "" }
    });
    this.setView("payout_history");
  };

  savePayoutAccount = async (e) => {
    e.preventDefault();
    const web_user_id = this.getUserId();
    const { payoutForm } = this.state;

    if (!web_user_id) return;

    const method = payoutForm.method;
    if (!payoutForm.accountName.trim()) {
      alert("Please enter the account holder name.");
      return;
    }
    if (!payoutForm.accountNumber.trim()) {
      alert("Please enter the account or wallet number.");
      return;
    }
    if (method === "bank" && !payoutForm.bankName.trim()) {
      alert("Please enter the bank name.");
      return;
    }

    const formData = new FormData();
    formData.append("web_user_id", web_user_id);
    formData.append("method", method);
    formData.append("account_name", payoutForm.accountName.trim());
    formData.append("account_number", payoutForm.accountNumber.trim());
    formData.append("bank_name", payoutForm.bankName.trim());
    formData.append("branch_name", payoutForm.branchName.trim());
    formData.append("routing_number", payoutForm.routingNumber.trim());

    try {
      this.setState({ savingPayoutAccount: true });
      const response = await axios.post(this.API.savePayoutAccount, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response?.data?.status === "success" || response?.data?.success) {
        alert("Withdrawal account saved successfully.");
        await this.fetchPayoutData();
        this.setState({ payoutTab: "withdrawals" });
      } else {
        alert(response?.data?.message || "Unable to save withdrawal account.");
      }
    } catch (error) {
      console.error("Save payout account error:", error);
      alert("Failed to save withdrawal account. Please try again.");
    } finally {
      this.setState({ savingPayoutAccount: false });
    }
  };

  submitWithdrawalRequest = async (e) => {
    e.preventDefault();

    const web_user_id = this.getUserId();
    const amount = this.toNumber(this.state.withdrawalForm.amount);
    const availableAmount = this.toNumber(this.state.payoutSummary.availableAmount);
    const account = this.state.payoutAccount;

    if (!web_user_id) return;

    if (!account || !account.account_number) {
      alert("Please setup your withdrawal account first.");
      this.setState({ payoutTab: "account" });
      return;
    }

    if (amount <= 0) {
      alert("Please enter a valid withdrawal amount.");
      return;
    }

    if (amount > availableAmount) {
      alert(`Maximum available amount is ${this.formatMoney(availableAmount)}.`);
      return;
    }

    const formData = new FormData();
    formData.append("web_user_id", web_user_id);
    formData.append("amount", amount);
    formData.append("payment_method", account.method || "bkash");
    formData.append("account_name", account.account_name || "");
    formData.append("account_number", account.account_number || "");
    formData.append("note", this.state.withdrawalForm.note.trim());

    try {
      this.setState({ requestingWithdrawal: true });
      const response = await axios.post(this.API.withdrawalRequest, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response?.data?.status === "success" || response?.data?.success) {
        alert("Withdrawal request submitted successfully. It is now waiting for approval.");
        this.setState({
          withdrawalForm: { amount: "", note: "" }
        });
        await this.fetchPayoutData();
      } else {
        alert(response?.data?.message || "Unable to submit withdrawal request.");
      }
    } catch (error) {
      console.error("Withdrawal request error:", error);
      alert("Failed to submit withdrawal request. Please try again.");
    } finally {
      this.setState({ requestingWithdrawal: false });
    }
  };

  handleMaxWithdrawal = () => {
    this.setState((prevState) => ({
      withdrawalForm: {
        ...prevState.withdrawalForm,
        amount: prevState.payoutSummary.availableAmount
      }
    }));
  };

  getWithdrawalStatusClass = (status) => {
    const normalized = this.normalizeStatus(status);
    if (["paid", "completed", "complete", "success", "successful"].includes(normalized)) return "paid";
    if (["approved", "processing"].includes(normalized)) return "approved";
    if (["rejected", "failed", "cancelled"].includes(normalized)) return "rejected";
    return "pending";
  };

  // ----------------------------- POPUPS / NAVIGATION -----------------------------
  openPopup = (popupName) => this.setState({ activePopup: popupName });

  closePopup = () => this.setState({ activePopup: null });

  handleCallUs = () => {
    window.location.href = `tel:${this.contactPhone}`;
  };

  handleWhatsApp = () => {
    window.open(
      `https://wa.me/${this.whatsappPhone}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  handleLogout = () => {
    localStorage.removeItem("web_user_id");
    localStorage.removeItem("token");
    localStorage.removeItem("access_token");
    this.setState({ activePopup: null });
    window.location.href = "/";
  };

  handleDeleteAccount = async () => {
    this.closePopup();
    alert("Delete account action confirmed. Please connect your backend API.");
  };

  // ----------------------------- ICONS -----------------------------
  BackIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  UserIcon = () => (
    <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8"/><path d="M5.5 20c.7-3.6 2.8-5.5 6.5-5.5s5.8 1.9 6.5 5.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
  );

  CalendarIcon = () => (
    <svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15.5" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8"/><path d="M7.5 3v4M16.5 3v4M3.5 9.5h17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
  );

  PhoneIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M7 4.5c.5-.4 1.2-.3 1.6.3l2 3.1c.4.6.3 1.3-.2 1.8l-1.2 1.1c.9 1.8 2.3 3.2 4.1 4.1l1.1-1.2c.5-.5 1.2-.6 1.8-.2l3.1 2c.6.4.7 1.1.3 1.6l-1.1 1.5c-.5.7-1.3 1-2.1.8-6.7-1.7-11.6-6.6-13.3-13.3-.2-.8.1-1.6.8-2.1L7 4.5Z" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  MailIcon = () => (
    <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8"/><path d="m4 7 8 6 8-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  EditIcon = () => (
    <svg viewBox="0 0 24 24"><path d="m14.5 5.5 4 4M5 19l1.2-4.4L16.8 4a2.2 2.2 0 0 1 3.2 3.2L9.4 17.8 5 19Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  PencilBadgeIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M15.2 3a2.1 2.1 0 0 1 3 3L7.5 16.7 3 18l1.3-4.5L15.2 3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  BellIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  WalletIcon = () => (
    <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8"/><path d="M3 9h18M14 13h3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>
  );

  BankIcon = () => (
    <svg viewBox="0 0 24 24"><path d="m3 9 9-5 9 5H3Z" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/><path d="M5 9v8M9 9v8M15 9v8M19 9v8M3 19h18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
  );

  MobileWalletIcon = () => (
    <svg viewBox="0 0 24 24"><rect x="6" y="2.8" width="12" height="18.4" rx="2.2" fill="none" stroke="currentColor" strokeWidth="1.7"/><path d="M9 5.5h6M11 18.2h2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
  );

  ArrowUpIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M12 18V6M7 11l5-5 5 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  CheckIcon = () => (
    <svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  CloseIcon = () => (
    <svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
  );

  LogoutIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M10 4H6.5A1.5 1.5 0 0 0 5 5.5v13A1.5 1.5 0 0 0 6.5 20H10" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M14 8l4 4-4 4M9 12h9" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  DeleteIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M4.5 7h15M9 7V4.5h6V7M7 7l.7 13h8.6L17 7M10 10.5v6M14 10.5v6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  WhatsAppIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M20.2 11.5a8.2 8.2 0 0 1-12.1 7.2L4 20l1.3-3.8A8.2 8.2 0 1 1 20.2 11.5Z" fill="none" stroke="currentColor" strokeWidth="1.7"/><path d="M8.5 8.4c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4-.1.6l-.6.7c.5 1 1.3 1.8 2.3 2.3l.7-.6c.2-.2.4-.2.6-.1l1.6.7c.3.1.4.3.4.5v.5c0 .3 0 .5-.4.7-.5.3-1.2.3-1.8.1-2.8-.9-5-3.1-5.9-5.9-.2-.6-.2-1.3.1-1.8Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  ChevronIcon = () => (
    <svg viewBox="0 0 24 24"><path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  RefreshIcon = () => (
    <svg viewBox="0 0 24 24"><path d="M21.5 2v6h-6M2.5 22v-6h6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M20 11.5A8.5 8.5 0 0 0 5.4 6.4L2.5 8.5M4 12.5a8.5 8.5 0 0 0 14.6 5.1l2.9-2.1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  EmptyReceiptIllustration = () => (
    <div className="empty-receipt-circle"><svg viewBox="0 0 24 24" className="empty-receipt-svg"><path d="M6 2v20l3-2 3 2 3-2 3 2V2l-3 2-3-2-3 2-3-2z" fill="none" stroke="currentColor" strokeWidth="1.5"/><path d="M9 7h6M9 11h6M9 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg></div>
  );

  renderAvatar = () => {
    const { fullName, customer_image } = this.state;

    return (
      <div className="profile-avatar-wrapper">
        <div className="profile-avatar">
          {customer_image ? (
            <img src={customer_image} alt="Profile" className="profile-avatar-image" />
          ) : (
            <span>{fullName ? fullName.charAt(0).toUpperCase() : "U"}</span>
          )}
        </div>

        <input ref={this.fileInputRef} type="file" accept="image/*" className="profile-file-input" onChange={this.handleFileChange} />
        <button type="button" className="profile-avatar-edit-badge" onClick={this.handleAvatarClick} aria-label="Change profile photo">
          <this.PencilBadgeIcon />
        </button>
      </div>
    );
  };

  renderField = ({ label, name, value, type = "text", icon: Icon, disabled = false, placeholder = "" }) => (
    <div className="profile-field">
      <label htmlFor={name}>{label}</label>
      <div className={`profile-input-wrapper ${disabled ? "profile-input-disabled" : ""}`}>
        <span className="profile-input-icon"><Icon /></span>
        <input id={name} type={type} name={name} value={value} onChange={this.handleChange} placeholder={placeholder} disabled={disabled} />
      </div>
    </div>
  );

  renderMainProfileView = () => {
    const { fullName, phone } = this.state;

    return (
      <div className="profile-main-mobile-layout">
        <div className="profile-simple-header"><h2>Profile</h2></div>

        <div className="profile-user-summary-section">
          {this.renderAvatar()}
          <h3 className="profile-user-name">{fullName || "User Profile"}</h3>
          <p className="profile-user-phone">{phone || "+8801XXXXXXXXX"}</p>
          <button type="button" className="profile-edit-btn-pill" onClick={() => this.setView("edit")}>Edit Profile</button>
        </div>

        <div className="profile-mobile-options-card">
          <button type="button" className="profile-mobile-option-item" onClick={() => this.openPopup("contact")}>
            <span className="profile-option-icon-wrap"><this.PhoneIcon /></span>
            <span className="profile-option-label">Get Help</span>
            <span className="profile-option-arrow-wrap"><this.ChevronIcon /></span>
          </button>

          <button type="button" className="profile-mobile-option-item" onClick={() => this.setView("notifications")}>
            <span className="profile-option-icon-wrap"><this.BellIcon /></span>
            <span className="profile-option-label">Notification</span>
            <span className="profile-option-arrow-wrap"><this.ChevronIcon /></span>
          </button>

          <button type="button" className="profile-mobile-option-item" onClick={() => this.setView("payment_history")}>
            <span className="profile-option-icon-wrap"><this.WalletIcon /></span>
            <span className="profile-option-label">Payment History</span>
            <span className="profile-option-arrow-wrap"><this.ChevronIcon /></span>
          </button>

          <button type="button" className="profile-mobile-option-item payout-menu-item" onClick={this.openPayoutSection}>
            <span className="profile-option-icon-wrap payout-menu-icon"><this.ArrowUpIcon /></span>
            <span className="profile-option-label">
              <strong>Payout History</strong>
              <small>Withdraw your confirmed earnings</small>
            </span>
            <span className="profile-option-arrow-wrap"><this.ChevronIcon /></span>
          </button>

          <button type="button" className="profile-mobile-option-item" onClick={() => this.openPopup("logout")}>
            <span className="profile-option-icon-wrap"><this.LogoutIcon /></span>
            <span className="profile-option-label">Logout</span>
            <span className="profile-option-arrow-wrap"><this.ChevronIcon /></span>
          </button>

          <button type="button" className="profile-mobile-option-item danger-option" onClick={() => this.openPopup("delete")}>
            <span className="profile-option-icon-wrap danger-icon"><this.DeleteIcon /></span>
            <span className="profile-option-label danger-text">Delete Account</span>
            <span className="profile-option-arrow-wrap"><this.ChevronIcon /></span>
          </button>
        </div>
      </div>
    );
  };

  renderNotificationsView = () => {
    const { notifications } = this.state;

    return (
      <div className="profile-subpage-container">
        <div className="subpage-header">
          <button type="button" className="subpage-back-btn" onClick={() => this.setView("main")}><this.BackIcon /></button>
          <h2 className="subpage-title">Notifications</h2>
        </div>

        <div className="subpage-content">
          {notifications?.length ? (
            <div className="notifications-list">
              {notifications.map((item) => (
                <div key={item.id} className={`notification-item ${item.unread ? "unread" : ""}`}>
                  <div className="notification-icon-col"><span className="notification-type-badge"><this.BellIcon /></span></div>
                  <div className="notification-details-col">
                    <div className="notification-header-row"><h4>{item.title}</h4><span className="notification-time">{item.time}</span></div>
                    <p>{item.message}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state-card center-aligned"><this.EmptyReceiptIllustration /><h3 className="empty-title">No notifications</h3><p className="empty-subtitle">You are all caught up.</p></div>
          )}
        </div>
      </div>
    );
  };

  renderPaymentTabs = () => {
    const { paymentTab, pastPayments, futurePayments } = this.state;

    return (
      <div className="payment-tabs-bar">
        <button type="button" className={`payment-tab-btn ${paymentTab === "past" ? "active" : ""}`} onClick={() => this.setPaymentTab("past")}>
          CONFIRMED & PAID <span>{pastPayments.length}</span>
        </button>
        <button type="button" className={`payment-tab-btn ${paymentTab === "future" ? "active" : ""}`} onClick={() => this.setPaymentTab("future")}>
          PENDING <span>{futurePayments.length}</span>
        </button>
      </div>
    );
  };

  renderPaymentCard = (item) => {
    const eligible = this.normalizeStatus(item.booking_status) === "confirmed" && this.normalizeStatus(item.payment_status) === "paid";
    const amount = this.getPaymentAmount(item);
    const alreadyRequested = this.isPaymentAlreadyAllocated(item, this.state.payoutHistory);

    return (
      <div key={item.id} className="payment-card-item">
        <div className="payment-card-header">
          <span className="payment-id">BOOKING #{item.id}</span>
          <div className="payment-status-wrapper">
            <span className={`payment-status-badge booking-${this.normalizeStatus(item.booking_status)}`}>{item.booking_status}</span>
            <span className={`payment-status-badge pay-${this.normalizeStatus(item.payment_status)}`}>{item.payment_status}</span>
          </div>
        </div>

        <div className="payment-card-body">
          <h4>{item.title || "Booking Payment"}</h4>
          {item.checkin_date && item.checkout_date && <p className="payment-date">📅 {item.checkin_date} to {item.checkout_date}</p>}
          {item.booking_date && <p className="payment-sub-date">Booked: {item.booking_date}</p>}
        </div>

        <div className="payment-card-footer">
          <span className="payment-method">Method: <strong>{item.payment_type ? item.payment_type.toUpperCase() : "N/A"}</strong></span>
          <strong className="payment-amount">{this.formatMoney(amount)}</strong>
        </div>

        {eligible && (
          <div className="payment-payout-row">
            <div>
              <span className="payment-payout-label">Host payout</span>
              <strong>{this.formatMoney(amount)}</strong>
            </div>
            {alreadyRequested ? (
              <span className="payout-booking-locked">Payout Requested</span>
            ) : (
              <button type="button" className="mini-payout-btn" onClick={this.openPayoutSection}>Request Payout</button>
            )}
          </div>
        )}
      </div>
    );
  };

  renderPaymentHistoryView = () => {
    const { paymentTab, pastPayments, futurePayments, loadingPayments, paymentsError } = this.state;
    const activeList = paymentTab === "past" ? pastPayments : futurePayments;

    return (
      <div className="profile-subpage-container">
        <div className="subpage-header">
          <button type="button" className="subpage-back-btn" onClick={() => this.setView("main")}><this.BackIcon /></button>
          <h2 className="subpage-title">Payment History</h2>
        </div>

        <div className="payment-info-strip">
          <span className="payment-info-dot"></span>
          <span>Confirmed + Paid bookings are eligible for host payout.</span>
        </div>

        {this.renderPaymentTabs()}

        <div className="subpage-content">
          {loadingPayments ? (
            <div className="profile-loading-card"><div className="profile-spinner" /><h3>Fetching Payments...</h3><p>Loading your booking transaction details.</p></div>
          ) : paymentsError ? (
            <div className="payment-error-card"><p>{paymentsError}</p><button type="button" className="payment-retry-btn" onClick={this.fetchBookingsData}><this.RefreshIcon /> Retry</button></div>
          ) : activeList?.length ? (
            <div className="payment-list">{activeList.map(this.renderPaymentCard)}</div>
          ) : (
            <div className="empty-state-card center-aligned"><this.EmptyReceiptIllustration /><h3 className="empty-title">No Payment Data</h3><p className="empty-subtitle">{paymentTab === "past" ? "No Confirmed & Paid booking payments found." : "No Pending & Unpaid booking payments found."}</p></div>
          )}
        </div>
      </div>
    );
  };

  renderPayoutSummary = () => {
    const { payoutSummary } = this.state;

    return (
      <div className="payout-summary-grid">
        <div className="payout-balance-card total-card">
          <div className="payout-balance-icon"><this.WalletIcon /></div>
          <span>Total Amount</span>
          <strong>{this.formatMoney(payoutSummary.totalAmount)}</strong>
          <small>Confirmed & paid earnings</small>
        </div>

        <div className="payout-balance-card pending-card">
          <div className="payout-balance-icon"><this.RefreshIcon /></div>
          <span>Pending Amount</span>
          <strong>{this.formatMoney(payoutSummary.pendingAmount)}</strong>
          <small>Withdrawal under review</small>
        </div>

        <div className="payout-balance-card withdrawn-card">
          <div className="payout-balance-icon"><this.CheckIcon /></div>
          <span>Already Withdrawn</span>
          <strong>{this.formatMoney(payoutSummary.withdrawnAmount)}</strong>
          <small>Completed payout</small>
        </div>

        <div className="payout-balance-card available-card">
          <div className="payout-balance-icon"><this.ArrowUpIcon /></div>
          <span>Available to Withdraw</span>
          <strong>{this.formatMoney(payoutSummary.availableAmount)}</strong>
          <small>Ready for your request</small>
        </div>
      </div>
    );
  };

  renderPayoutTabs = () => {

    const { payoutTab, payoutHistory, payoutAccount } = this.state;

    return (
      <div className="payout-tabs-bar">
        <button type="button" className={`payout-tab-btn ${payoutTab === "withdrawals" ? "active" : ""}`} onClick={() => this.setPayoutTab("withdrawals")}>
          WITHDRAWALS <span>{payoutHistory.length}</span>
        </button>
        <button type="button" className={`payout-tab-btn ${payoutTab === "account" ? "active" : ""}`} onClick={() => this.setPayoutTab("account")}>
          PAYOUT ACCOUNT <span>{payoutAccount?.account_number ? "✓" : "Setup"}</span>
        </button>
      </div>
    );
  };

  renderWithdrawalForm = () => {
    
    const { payoutSummary, payoutAccount, withdrawalForm, requestingWithdrawal } = this.state;
    const available = this.toNumber(payoutSummary.availableAmount);

    return (
      <div className="withdrawal-request-card">
        <div className="section-card-heading">
          <div>
            <span className="section-eyebrow">NEW REQUEST</span>
            <h3>Request a Withdrawal</h3>
            <p>Submit a request from your available host earnings.</p>
          </div>
          <div className="section-heading-icon"><this.ArrowUpIcon /></div>
        </div>

        <div className="withdrawal-available-box">
          <span>Available to withdraw</span>
          <strong>{this.formatMoney(available)}</strong>
        </div>

        {!payoutAccount?.account_number ? (
          <div className="payout-setup-warning">
            <div className="warning-icon">!</div>
            <div>
              <strong>Withdrawal account is not setup</strong>
              <p>Add your bank or digital wallet before requesting a withdrawal.</p>
              <button type="button" onClick={() => this.setPayoutTab("account")}>Setup Withdrawal Account</button>
            </div>
          </div>
        ) : (
          <>
            <div className="selected-payout-account">
              <div className="selected-account-icon"><this.MobileWalletIcon /></div>
              <div className="selected-account-text">
                <span>{String(payoutAccount.method || "bkash").toUpperCase()}</span>
                <strong>{payoutAccount.account_name || "Account holder"}</strong>
                <small>{payoutAccount.account_number}</small>
              </div>
              <button type="button" onClick={() => this.setPayoutTab("account")}>Change</button>
            </div>

            <form onSubmit={this.submitWithdrawalRequest} className="withdrawal-form">
              <div className="payout-field">
                <div className="payout-field-label-row">
                  <label htmlFor="withdrawalAmount">Withdrawal Amount</label>
                  <button type="button" onClick={this.handleMaxWithdrawal}>Use Maximum</button>
                </div>
                <div className="amount-input-wrapper">
                  <span>৳</span>
                  <input id="withdrawalAmount" type="number" min="1" step="0.01" max={available} name="amount" value={withdrawalForm.amount} onChange={this.handleWithdrawalChange} placeholder="0.00" />
                </div>
              </div>

              <div className="payout-field">
                <label htmlFor="withdrawalNote">Note <span>(optional)</span></label>
                <textarea id="withdrawalNote" name="note" value={withdrawalForm.note} onChange={this.handleWithdrawalChange} rows="3" placeholder="Add a note for the admin..." />
              </div>

              <div className="withdrawal-process-note">
                <strong>What happens next?</strong>
                <p>Your request will be reviewed by admin. After approval, the payout will be sent to your selected account.</p>
              </div>

              <button type="submit" className="primary-wide-btn" disabled={requestingWithdrawal || available <= 0}>
                {requestingWithdrawal ? <><span className="button-spinner" /> Submitting...</> : <><this.ArrowUpIcon /> Submit Withdrawal Request</>}
              </button>
            </form>
          </>
        )}
      </div>
    );
  };

  renderWithdrawalHistory = () => {
    const { payoutHistory, loadingPayout, payoutError } = this.state;

    return (
      <div className="payout-history-content">
        {loadingPayout ? (
          <div className="profile-loading-card"><div className="profile-spinner" /><h3>Loading Payouts...</h3><p>Preparing your withdrawal information.</p></div>
        ) : payoutError ? (
          <div className="payment-error-card"><p>{payoutError}</p><button type="button" className="payment-retry-btn" onClick={this.fetchPayoutData}><this.RefreshIcon /> Retry</button></div>
        ) : (
          <>
            {this.renderWithdrawalForm()}

            <div className="withdrawal-history-card">
              <div className="history-card-title-row">
                <div>
                  <span className="section-eyebrow">ACTIVITY</span>
                  <h3>Withdrawal History</h3>
                </div>
                <span className="history-count">{payoutHistory.length} {payoutHistory.length === 1 ? "request" : "requests"}</span>
              </div>

              {payoutHistory.length ? (
                <div className="withdrawal-list">
                  {payoutHistory.map((item, index) => {

                    const status = item.payout_status || "Pending";
                    const statusClass = this.getWithdrawalStatusClass(status);
                    const account = item.account_number || "Account";

                    return (
                      <div className="withdrawal-history-item" key={item.id || `${item.booking_id || "request"}-${index}`}>
                        <div className={`withdrawal-status-icon ${statusClass}`}>
                          {statusClass === "paid" ? <this.CheckIcon /> : statusClass === "rejected" ? <this.CloseIcon /> : <this.RefreshIcon />}
                        </div>
                        <div className="withdrawal-history-main">
                          <div className="withdrawal-history-top">
                            <strong>{this.formatMoney(item.payout_amount)}</strong>
                            <span className={`withdrawal-status ${statusClass}`}>{status}</span>
                          </div>
                          <p>{String(item.payout_method|| "Payout").toUpperCase()} • {account}</p>
                          <small>{item.payout_date || "Request date unavailable"}</small>
                          {item.rejection_reason && <em>{item.rejection_reason}</em>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="small-empty-state">
                  <div className="small-empty-icon"><this.ArrowUpIcon /></div>
                  <strong>No withdrawal requests yet</strong>
                  <p>Your approved payout requests will appear here.</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  renderPayoutAccount = () => {
    const { payoutForm, payoutAccount, savingPayoutAccount } = this.state;
    const hasAccount = !!payoutAccount?.account_number;

    return (
      <div className="payout-account-content">
        <div className="withdrawal-request-card">
          <div className="section-card-heading">
            <div>
              <span className="section-eyebrow">STEP 01</span>
              <h3>Withdrawal Account</h3>
              <p>Choose where your host earnings should be sent.</p>
            </div>
            <div className="section-heading-icon"><this.BankIcon /></div>
          </div>

          <div className="account-method-grid">
            {[
              { id: "bkash", label: "bKash", icon: this.MobileWalletIcon },
              { id: "nagad", label: "Nagad", icon: this.MobileWalletIcon },
              { id: "rocket", label: "Rocket", icon: this.MobileWalletIcon },
              { id: "bank", label: "Bank", icon: this.BankIcon }
            ].map((method) => {
              const Icon = method.icon;
              return (
                <button type="button" key={method.id} className={`account-method-btn ${payoutForm.method === method.id ? "active" : ""}`} onClick={() => this.handlePayoutMethodChange(method.id)}>
                  <span><Icon /></span>
                  <strong>{method.label}</strong>
                </button>
              );
            })}
          </div>

          <form onSubmit={this.savePayoutAccount} className="withdrawal-form">
            <div className="payout-field">
              <label htmlFor="accountName">Account Holder Name</label>
              <input id="accountName" className="standalone-payout-input" type="text" name="accountName" value={payoutForm.accountName} onChange={this.handlePayoutAccountChange} placeholder="Name as registered with account" />
            </div>

            <div className="payout-field">
              <label htmlFor="accountNumber">{payoutForm.method === "bank" ? "Bank Account Number" : "Wallet Number"}</label>
              <input id="accountNumber" className="standalone-payout-input" type="text" name="accountNumber" value={payoutForm.accountNumber} onChange={this.handlePayoutAccountChange} placeholder={payoutForm.method === "bank" ? "Enter bank account number" : "01XXXXXXXXX"} inputMode={payoutForm.method === "bank" ? "numeric" : "tel"} />
            </div>

            {payoutForm.method === "bank" && (
              <>
                <div className="payout-field">
                  <label htmlFor="bankName">Bank Name</label>
                  <input id="bankName" className="standalone-payout-input" type="text" name="bankName" value={payoutForm.bankName} onChange={this.handlePayoutAccountChange} placeholder="e.g. Dutch-Bangla Bank" />
                </div>
                <div className="two-column-payout-fields">
                  <div className="payout-field"><label htmlFor="branchName">Branch</label><input id="branchName" className="standalone-payout-input" type="text" name="branchName" value={payoutForm.branchName} onChange={this.handlePayoutAccountChange} placeholder="Branch name" /></div>
                  <div className="payout-field"><label htmlFor="routingNumber">Routing</label><input id="routingNumber" className="standalone-payout-input" type="text" name="routingNumber" value={payoutForm.routingNumber} onChange={this.handlePayoutAccountChange} placeholder="Routing number" /></div>
                </div>
              </>
            )}

            <div className="payout-account-security-note">
              <div className="security-lock">✓</div>
              <div><strong>Use your own verified account</strong><p>Make sure the account details are correct before submitting a withdrawal request.</p></div>
            </div>

            <button type="submit" className="primary-wide-btn" disabled={savingPayoutAccount}>
              {savingPayoutAccount ? <><span className="button-spinner" /> Saving...</> : <><this.CheckIcon /> {hasAccount ? "Update Withdrawal Account" : "Save Withdrawal Account"}</>}
            </button>
          </form>
        </div>

        {hasAccount && (
          <div className="current-account-preview">
            <span className="section-eyebrow">CURRENT ACCOUNT</span>
            <div className="current-account-row">
              <div className="current-account-icon"><this.MobileWalletIcon /></div>
              <div><strong>{String(payoutAccount.method || "").toUpperCase()}</strong><span>{payoutAccount.account_name}</span><small>{payoutAccount.account_number}</small></div>
              <span className="verified-badge">Saved</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  renderPayoutHistoryView = () => {
    const { payoutTab, payoutSummary, payoutAccount } = this.state;

    return (
      <div className="profile-subpage-container payout-subpage-container">
        <div className="subpage-header payout-header">
          <button type="button" className="subpage-back-btn" onClick={() => this.setView("main")}><this.BackIcon /></button>
          <div className="payout-title-block"><h2 className="subpage-title">Payout History</h2><span>Host earnings & withdrawals</span></div>
          <button type="button" className="payout-refresh-btn" onClick={this.fetchPayoutData}><this.RefreshIcon /></button>
        </div>

        <div className="payout-overview-banner">
          <div><span>Available for withdrawal</span><strong>{this.formatMoney(payoutSummary.availableAmount)}</strong><small>Only confirmed & paid booking earnings can be requested.</small></div>
          <div className="payout-banner-icon"><this.ArrowUpIcon /></div>
        </div>

        {this.renderPayoutSummary()}

        <div className="payout-steps-line"><span className="step-active">1</span><span>Earn</span><i></i><span>2</span><span>Request</span><i></i><span>3</span><span>Admin Approval</span><i></i><span>4</span><span>Paid</span></div>

        {!payoutAccount?.account_number && (
          <div className="payout-account-alert">
            <div className="payout-account-alert-icon"><this.BankIcon /></div>
            <div><strong>Setup your withdrawal account</strong><p>Add bKash, Nagad, Rocket or bank information before requesting a payout.</p></div>
            <button type="button" onClick={() => this.setPayoutTab("account")}>Setup</button>
          </div>
        )}

        {this.renderPayoutTabs()}

        <div className="subpage-content">
          {payoutTab === "withdrawals" ? this.renderWithdrawalHistory() : this.renderPayoutAccount()}
        </div>
      </div>
    );
  };

  renderEditProfileView = () => {
    const { fullName, dob, phone, email, saving, loading } = this.state;

    return (
      <div className="profile-subpage-container">
        <div className="subpage-header"><button type="button" className="subpage-back-btn" onClick={() => this.setView("main")}><this.BackIcon /></button><h2 className="subpage-title">Edit Profile</h2></div>

        <div className="subpage-content">
          <section className="profile-edit-card">
            <div className="profile-edit-header">
              <div><span className="profile-section-label">ACCOUNT INFORMATION</span><h3>Personal Information</h3><p>Update your details below.</p></div>
              <div className="profile-edit-header-icon"><this.EditIcon /></div>
            </div>

            <form onSubmit={this.handleSave}>
              <div className="profile-form-grid">
                {this.renderField({ label: "Full Name", name: "fullName", value: fullName, icon: this.UserIcon, placeholder: "Enter your full name" })}
                {this.renderField({ label: "Date of birth", name: "dob", value: dob, type: "date", icon: this.CalendarIcon })}
                {this.renderField({ label: "Phone number", name: "phone", value: phone, type: "tel", icon: this.PhoneIcon, disabled: true })}
              </div>

              <div className="profile-email-note"><span className="profile-email-icon"><this.MailIcon /></span><div><strong>Email address</strong><span>{email || "No email address available"}</span></div><span className="profile-readonly-badge">Account</span></div>

              <div className="profile-form-actions">
                <button type="button" className="profile-cancel-button" onClick={this.handleCancel} disabled={saving}><this.CloseIcon /> Cancel</button>
                <button type="submit" className="profile-save-button" disabled={saving || loading}>{saving ? <><span className="button-spinner" /> Saving...</> : <><this.CheckIcon /> Save Changes</>}</button>
              </div>
            </form>
          </section>
        </div>
      </div>
    );
  };

  renderPopup = () => {
    const { activePopup } = this.state;
    if (!activePopup) return null;

    if (activePopup === "contact") {
      return (
        <div className="profile-modal-overlay" onClick={this.closePopup}>
          <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="profile-modal-close" onClick={this.closePopup}><this.CloseIcon /></button>
            <div className="profile-modal-icon profile-modal-contact"><this.PhoneIcon /></div>
            <h3>Contact Us</h3><p>Choose how you would like to contact our support team.</p>
            <div className="profile-contact-actions">
              <button type="button" className="profile-contact-button profile-call-button" onClick={this.handleCallUs}><span><this.PhoneIcon /></span><div><strong>Call Us</strong><small>{this.contactPhone}</small></div></button>
              <button type="button" className="profile-contact-button profile-whatsapp-button" onClick={this.handleWhatsApp}><span><this.WhatsAppIcon /></span><div><strong>WhatsApp Us</strong><small>Chat with support team</small></div></button>
            </div>
            <button type="button" className="profile-modal-secondary" onClick={this.closePopup}>Cancel</button>
          </div>
        </div>
      );
    }

    if (activePopup === "logout") {
      return (
        <div className="profile-modal-overlay" onClick={this.closePopup}>
          <div className="profile-modal profile-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="profile-modal-close" onClick={this.closePopup}><this.CloseIcon /></button>
            <div className="profile-modal-icon profile-modal-logout"><this.LogoutIcon /></div>
            <h3>Logout?</h3><p>Are you sure you want to logout from your account?</p>
            <div className="profile-confirm-actions"><button type="button" className="profile-modal-secondary" onClick={this.closePopup}>Cancel</button><button type="button" className="profile-modal-danger" onClick={this.handleLogout}><this.LogoutIcon /> Logout</button></div>
          </div>
        </div>
      );
    }

    if (activePopup === "delete") {
      return (
        <div className="profile-modal-overlay" onClick={this.closePopup}>
          <div className="profile-modal profile-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="profile-modal-close" onClick={this.closePopup}><this.CloseIcon /></button>
            <div className="profile-modal-icon profile-modal-delete"><this.DeleteIcon /></div>
            <h3>Delete Account?</h3><p>Are you sure you want to delete your account? This action cannot be undone.</p>
            <div className="profile-confirm-actions"><button type="button" className="profile-modal-secondary" onClick={this.closePopup}>Cancel</button><button type="button" className="profile-modal-danger" onClick={this.handleDeleteAccount}><this.DeleteIcon /> Delete Account</button></div>
          </div>
        </div>
      );
    }

    return null;
  };

  render() {
    const { currentView, loading } = this.state;

    return (
      <div className="profile-container">
        {loading ? (
          <div className="profile-loading-card"><div className="profile-spinner" /><h3>Loading profile</h3><p>Please wait while we load your information.</p></div>
        ) : (
          <>
            {currentView === "main" && this.renderMainProfileView()}
            {currentView === "edit" && this.renderEditProfileView()}
            {currentView === "notifications" && this.renderNotificationsView()}
            {currentView === "payment_history" && this.renderPaymentHistoryView()}
            {currentView === "payout_history" && this.renderPayoutHistoryView()}
          </>
        )}
        {this.renderPopup()}
      </div>
    );
  }
}

export default ProfileMobile;
